<template src="./AppointmentsHistory.html"></template>
<script>
export default {
  name: "appointments-history",
  props: ["patientId"],
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      rating: [],
      appointmentId: null,
      ratingAppointment: 0,
      ratingAppUse: 0,
      ratingServiceQuality: 0,
      ratingDoctors: 0,
      ratingAppointmentRadio: false,
      ratingAppUseRadio: false,
      ratingServiceQualityRadio: false,
      ratingDoctorsRadio: false,
      afterAppointment: null,
      clinicalSummary: null,
      starSize: 30,
      showWebTable: true,
      histories: [],
      idMedicalRecord: 0,
      isNewAppointment: false,
      openNewWindow: false,
      showBackButton: false,
      popupRating: false
    };
  },
  watch: {
    ratingAppointmentRadio: function(newVal) {
      const vm = this;
      if (newVal == true) vm.ratingAppointment = 0;
    },
    ratingAppUseRadio: function(newVal) {
      const vm = this;
      if (newVal == true) vm.ratingAppUse = 0;
    },
    ratingServiceQualityRadio: function(newVal) {
      const vm = this;
      if (newVal == true) vm.ratingServiceQuality = 0;
    },
    ratingDoctorsRadio: function(newVal) {
      const vm = this;
      if (newVal == true) vm.ratingDoctors = 0;
    }
  },
  computed: {
    isProject() {
      return this.$session.get("isProject") ? this.$session.get("isProject") : false;
    },
    scheduledDateStyle() {
      return this.isProject ? {maxWidth: '15%', width: '15%'} : {maxWidth: '5%', width: '5%'};
    },
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  mounted: function() {
    const vm = this;
    if (vm.$route.name === "pages-doctor") {
      vm.showBackButton = false;
    } else {
      vm.showBackButton = true;
    }
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getAppointmentHistory();
    },
    getAppointmentHistory() {
      const vm = this;

      var idPatient = vm.$props.patientId;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "consultant/patients/" +
            idPatient +
            "/historic-appointments?page=0&size=50&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearer") },
            options: {
              page: 0,
              size: 20,
              sort: ["id", "desc"]
            }
          }
        )
        .then(function(response) {
          vm.histories = response.data.content;
          for (let h in vm.histories) {
            if (vm.histories[h].status === "HISTORY_CONCLUDED") {
              vm.histories[h].status = "Realizada";
            }
            if (vm.histories[h].didAfterAppointment === false) {
              vm.histories[h].qualityAssessment = "Não preenchida";
            } else {
              vm.histories[h].qualityAssessment = "Preenchida";
            }
          }
        });
    },
    setRatingAppointment() {
      const vm = this;
      if (vm.rantingAppointment == 0) {
        vm.ratingAppointmentRadio = true;
      } else {
        vm.ratingAppointmentRadio = false;
      }
    },
    setRatingAppUse() {
      const vm = this;
      if (vm.ratingAppUse == 0) {
        vm.ratingAppUseRadio = true;
      } else {
        vm.ratingAppUseRadio = false;
      }
    },
    setRatingServiceQuality() {
      const vm = this;
      if (vm.ratingServiceQuality == 0) {
        vm.ratingServiceQualityRadio = true;
      } else {
        vm.ratingServiceQualityRadio = false;
      }
    },
    setRatingDoctors() {
      const vm = this;
      if (vm.ratingDoctors == 0) {
        vm.ratingDoctorsRadio = true;
      } else {
        vm.ratingDoctorsRadio = false;
      }
    },
    rantingAppointment(appointmentId) {
      const vm = this;
      vm.popupRating = true;
      vm.appointmentId = appointmentId;
      vm.getRatingAppointment(appointmentId);
    },
    getRatingAppointment(appointmentId) {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "consultant/patients/" +
            vm.$props.patientId +
            "/after-appointments/" +
            appointmentId,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.rating = response.data;
            vm.fillRatingFields();
          }
        })
    },
    fillRatingFields(){
      const vm = this;

       vm.ratingAppointment = vm.rating.rating.appointment;
            vm.ratingAppUse = vm.rating.rating.app;
            vm.ratingServiceQuality = vm.rating.rating.quality;
            vm.ratingDoctors = vm.rating.rating.doctor;
            vm.clinicalSummary = vm.rating.clinicalSummary;
            vm.afterAppointment = vm.rating.afterAppointment;

            if (vm.ratingAppointment == 0) {
              vm.ratingAppointmentRadio = true;
            }
            else {
              vm.ratingAppointmentRadio = false;
            }
            if (vm.ratingAppUse == 0) {
              vm.ratingAppUseRadio = true;
            }
            else {
               vm.ratingAppUseRadio = false;
            }
            if (vm.ratingServiceQuality == 0) {
              vm.ratingServiceQualityRadio = true;
            }
            else {
              vm.ratingServiceQualityRadio = false;
            }
            if (vm.ratingDoctors == 0) {
              vm.ratingDoctorsRadio = true;
            }
            else {
              vm.ratingDoctorsRadio = false;
            }
    },
    goBackToRegistrationData() {
      const vm = this;
      vm.$emit("goToRegistrationData", event);
    },
    putRanting() {
      const vm = this;
      let ranting = {
        id: vm.rating.id !== null ? vm.rating.id : null,
        scheduleId: vm.rating.scheduleId,
        appointmentId: vm.rating.appointmentId,
        medicalRecordId: vm.rating.medicalRecordId,
        rating: {
          appointment: vm.ratingAppointment,
          app: vm.ratingAppUse,
          quality: vm.ratingServiceQuality,
          doctor: vm.ratingDoctors
        },
        appointment: vm.ratingAppointment,
        app: vm.ratingAppUse,
        quality: vm.ratingServiceQuality,
        doctor: vm.ratingDoctors,
        afterAppointment: vm.afterAppointment,
        clinicalSummary: vm.clinicalSummary,
        ratingObservation: null
      };
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "consultant/patients/" +
            vm.$props.patientId +
            "/after-appointments/" +
            vm.appointmentId, ranting,
          {
            headers: { Authorization: vm.$session.get("bearer") }
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.popupRating = false;
            vm.$swal({
              title: "Sucesso!",
              text: "Avaliação salva com sucesso",
              icon: "success"
            }).then(function() {
              vm.getAppointmentHistory();
            });
          }
        })
        .catch(function() {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível executar esta operação.Por favor, entre em contato com o administrador do sistema. ",
            icon: "error"
          });
        });
    },
    handleResize() {
      const vm = this;
      vm.window.width = window.innerWidth;
      vm.window.height = window.innerHeight;
      if (vm.window.width < 380) {
        vm.starSize = 20;
      }
      if (vm.window.width < 1140) {
        vm.showWebTable = false;
      } else {
        vm.showWebTable = true;
      }
    }
  }
};
</script>
<style src="./AppointmentsHistory.css">
</style>
